<template>
    <div>
        <v-container v-if="estadoComp">
            <v-card class="pa-5" elevation="0">
                <v-card-text>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="text-overline mb-4 d-flex">
                                <v-img class="mr-2" max-height="30" max-width="25" contain
                                    src="https://static-00.iconduck.com/assets.00/open-book-emoji-2048x1756-oengc244.png"></v-img>
                                <h1> {{ parametros.titulo }} </h1>
                            </div>
                            <v-list-item-subtitle> {{ parametros.subtitulo }}
                                <v-chip class="ma-2" color="warning" text-color="black">
                                    <v-icon left>
                                        mdi-information-outline
                                    </v-icon>
                                    Por realizar
                                </v-chip>
                            </v-list-item-subtitle>

                            <v-row dense class="my-4">                              

                                <v-col cols="6" v-for="(item, i) in parametros.contenidoCuerpo" :key="i">
                                    
                                    <!--  -->
                                    <v-alert border="left" dense outlined color="#cdcdcd" class="pa-6">
                                        <h4 class="text-h5 black--text">
                                            <v-icon left color="#6b6b6b">{{item.icon}}</v-icon>
                                            {{ item.text }}
                                        </h4>                                    
                                        <!-- <v-divider class="my-4 info" style="opacity: 0.22"></v-divider> -->
                                        <div class="black--text pt-2" v-html="item.subtext"></div>                                
                                    </v-alert>

                                </v-col>
                            </v-row>

                            <div class="">
                                <h3 class="py-8"> Información adicional </h3>
                                <v-list dense>
                                    <v-list-item class="pa-0" v-for="(item, i) in parametros.contenidoAdicional"
                                        :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="pt-0">
                                            <v-list-item-title v-html="item.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>

                <v-card-actions>
                    <v-row>
                        <v-col class="text-end">
                            <v-btn @click="$emit('click')" color="primary"> <v-icon>mdi-chevron-right</v-icon> Iniciar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>

            </v-card>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'introExamenTemplate',
    props: {
        parametros: {
            type: Object,
            default() {
                return {};
            }
        },
        estadoComp: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },

    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
}
</script>